(function() {
  if (window.__eliteWindTimer) {
    clearInterval(window.__eliteWindTimer.gauge1);
    clearInterval(window.__eliteWindTimer.history1);
    clearInterval(window.__eliteWindTimer.gauge2);
    clearInterval(window.__eliteWindTimer.history2);
  }
  window.__eliteWindTimer = {};

  function msUntilNextTenMin() {
    const now = new Date();
    const ms = ((10 - (now.getMinutes() % 10)) % 10) * 60 * 1000;
    return ms === 0 ? 10 * 60 * 1000 : ms - now.getSeconds() * 1000 - now.getMilliseconds();
  }

  function degreesToCardinal(deg) {
    const dirs = ['N','NNE','NE','ENE','E','ESE','SE','SSE','S','SSW','SW','WSW','W','WNW','NW','NNW'];
    return dirs[Math.round(deg / 22.5) % 16];
  }

  function formatTime(utc) {
    const d = new Date(utc);
    return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  }

  const windDirPlugin = {
    id: 'windDirArrows',
    afterDraw(chart) {
      const { ctx, chartArea, scales } = chart;
      const dirData = chart.config._windDirs;
      if (!dirData || !dirData.length) return;
      const xScale = scales.x;
      const arrowSize = 10;
      const arrowY = chartArea.bottom - 16;
      ctx.save();
      ctx.strokeStyle = '#ff6b00';
      ctx.lineWidth = 1.5;
      dirData.forEach(({ index, dir }) => {
        const x = xScale.getPixelForValue(index);
        ctx.save();
        ctx.translate(x, arrowY);
        ctx.rotate(((dir + 180) * Math.PI) / 180);
        ctx.beginPath();
        ctx.moveTo(0, -arrowSize);
        ctx.lineTo(arrowSize * 0.5, arrowSize * 0.5);
        ctx.lineTo(0, arrowSize * 0.2);
        ctx.lineTo(-arrowSize * 0.5, arrowSize * 0.5);
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
      });
      ctx.restore();
    }
  };

  const peakLabelPlugin = {
    id: 'peakLabel',
    afterDraw(chart) {
      const { ctx, scales } = chart;
      const dataset = chart.data.datasets[0];
      if (!dataset || !dataset.data.length) return;

      const startIndex = chart.config._peakFromIndex ?? 0;
      let peakIndex = startIndex;
      let peakValue = -Infinity;
      dataset.data.forEach((v, i) => {
        if (i < startIndex) return;
        if (v != null && v > peakValue) {
          peakValue = v;
          peakIndex = i;
        }
      });

      if (peakValue === -Infinity) return;

      const x = scales.x.getPixelForValue(peakIndex);
      const y = scales.y.getPixelForValue(peakValue);

      ctx.save();
      ctx.font = 'bold 16px sans-serif';
      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'bottom';
      ctx.fillText(peakValue.toFixed(1) + ' kts', x, y - 6);
      ctx.restore();
    }
  };

  function createSensor({ workerUrl, speedId, cardinalId, arrowId, updatedId, chartCanvasId, loadingId }) {
    let historyChart = null;

    async function updateGauge() {
      try {
        const res = await fetch(`${workerUrl}/current`);
        const data = await res.json();
        document.getElementById(speedId).textContent =
          data.windspeed_kts != null ? data.windspeed_kts.toFixed(1) : '--';
        document.getElementById(cardinalId).textContent =
          data.winddir != null ? degreesToCardinal(data.winddir) : '--';
        const snapped = Math.round((data.winddir || 0) / 22.5) * 22.5;
        document.getElementById(arrowId).setAttribute('transform', `rotate(${snapped} 100 100)`);
        document.getElementById(updatedId).textContent =
          data.dateutc ? formatTime(data.dateutc) : '';
      } catch (e) {
        console.error(`updateGauge failed (${workerUrl}):`, e);
        document.getElementById(speedId).textContent = '--';
      }
    }

    async function updateHistory() {
      try {
        const res = await fetch(`${workerUrl}/history`);
        const data = await res.json();
        const loading = document.getElementById(loadingId);
        if (loading) loading.style.display = 'none';

        const isMobile = window.innerWidth <= 768;
        const now = new Date();
        const fiveAM = new Date(now);
        fiveAM.setHours(5, 0, 0, 0);
        const cutoff = Date.now() - (12 * 60 * 60 * 1000);
        const filtered = data.filter(d => d.dateutc >= cutoff);
        const labels = filtered.map(d => formatTime(d.dateutc));
        const speeds = filtered.map(d => d.windspeed_kts);
        const peakFromIndex = Math.max(0, filtered.findIndex(d => d.dateutc >= fiveAM.getTime()));
        const arrowInterval = isMobile ? 6 : 3;
        const windDirs = filtered
          .map((d, i) => ({ index: i, dir: d.winddir }))
          .filter((_, i) => i % arrowInterval === 0);

        if (historyChart) {
          historyChart.data.labels = labels;
          historyChart.data.datasets[0].data = speeds;
          historyChart.config._windDirs = windDirs;
          historyChart.config._peakFromIndex = peakFromIndex;
          historyChart.update();
        } else {
          historyChart = new Chart(document.getElementById(chartCanvasId), {
            type: 'line',
            data: {
              labels,
              datasets: [{
                label: 'Wind Speed (knots)',
                data: speeds,
                borderColor: '#ff6b00',
                backgroundColor: 'rgba(255,107,0,0.1)',
                borderWidth: 2,
                pointRadius: 0,
                tension: 0.3,
                fill: true
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: { legend: { display: false } },
              layout: { padding: { bottom: 10, top: 20 } },
              scales: {
                x: {
                  ticks: {
                    color: '#ffffff',
                    maxRotation: 0,
                    autoSkip: true,
                    autoSkipPadding: 30,
                    font: { size: 12 },
                    maxTicksLimit: isMobile ? 5 : 12
                  },
                  grid: { color: '#222' }
                },
                y: {
                  min: 0,
                  suggestedMax: 15,
                  ticks: { color: '#ffffff', font: { size: 14 } },
                  grid: { color: '#222' },
                  title: { display: true, text: 'knots', color: '#ff6b00', font: { size: 18 } }
                }
              }
            },
            plugins: [windDirPlugin, peakLabelPlugin]
          });
          historyChart.config._windDirs = windDirs;
          historyChart.config._peakFromIndex = peakFromIndex;
        }
      } catch (e) {
        console.error(`updateHistory failed (${workerUrl}):`, e);
        const loading = document.getElementById(loadingId);
        if (loading) loading.textContent = 'Unable to load history.';
      }
    }

    return { updateGauge, updateHistory };
  }

  // — Sensor 1: T-Bay
  const s1 = createSensor({
    workerUrl: 'https://elite-windsensor.scott-bc7.workers.dev',
    speedId: 'windSpeed',
    cardinalId: 'windCardinal',
    arrowId: 'windArrow',
    updatedId: 'windUpdated',
    chartCanvasId: 'windHistoryChart',
    loadingId: 'windModalLoading'
  });

  // — Sensor 2: PAG
  const s2 = createSensor({
    workerUrl: 'https://elite-windsensor-2.scott-bc7.workers.dev',
    speedId: 'windSpeed2',
    cardinalId: 'windCardinal2',
    arrowId: 'windArrow2',
    updatedId: 'windUpdated2',
    chartCanvasId: 'windHistoryChart2',
    loadingId: 'windModalLoading2'
  });

  // Initial gauge loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { s1.updateGauge(); s2.updateGauge(); });
  } else {
    s1.updateGauge();
    s2.updateGauge();
  }

  // Sync updates to next 10-min mark
  const delay = msUntilNextTenMin();
  setTimeout(() => {
    s1.updateGauge(); s2.updateGauge();
    window.__eliteWindTimer.gauge1 = setInterval(s1.updateGauge, 10 * 60 * 1000);
    window.__eliteWindTimer.gauge2 = setInterval(s2.updateGauge, 10 * 60 * 1000);
  }, delay);

  // Visibility change refresh
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      s1.updateGauge(); s1.updateHistory();
      s2.updateGauge(); s2.updateHistory();
    }
  });

  // Wait for Chart.js then load history
  function waitForChart() {
    if (typeof Chart !== 'undefined') {
      Chart.register(windDirPlugin, peakLabelPlugin);
      s1.updateHistory(); s2.updateHistory();
      setTimeout(() => {
        s1.updateHistory(); s2.updateHistory();
        window.__eliteWindTimer.history1 = setInterval(s1.updateHistory, 10 * 60 * 1000);
        window.__eliteWindTimer.history2 = setInterval(s2.updateHistory, 10 * 60 * 1000);
      }, delay);
    } else {
      setTimeout(waitForChart, 100);
    }
  }
  waitForChart();

})();
